/* ================================================================
   VM³ PUREFIER — THEME.JS
   Cart Drawer, Mobile Nav, FAQ, Toast, Add to Cart
   ================================================================ */

'use strict';

// ── CART DRAWER ──────────────────────────────────────────────────
// ── CART DRAWER ──────────────────────────────────────────────────
const CartDrawer = {

  body: document.body,

  getDrawer() {
    return document.querySelector('#cart-drawer, .cart-drawer');
  },

  getOverlay() {
    return document.querySelector('.cart-overlay');
  },

  // ── MONEY ─────────────────────────────────────────────────────
  formatMoney(amount, currency) {

    const value =
      (Number(amount) / 100).toFixed(2);

    const code =
      currency || 'AUD';

    // AUD / USD
    if (
      code === 'AUD' ||
      code === 'USD'
    ) {
      return `$${value}`;
    }

    // Other currencies
    try {

      return new Intl.NumberFormat(
        undefined,
        {
          style: 'currency',
          currency: code
        }
      ).format(
        Number(amount) / 100
      );

    } catch (e) {

      return `${code} ${value}`;

    }
  },


  // ── OPEN ──────────────────────────────────────────────────────
  open() {

    const drawer =
      this.getDrawer();

    const overlay =
      this.getOverlay();

    console.log(
      'Opening cart drawer...',
      drawer
    );

    if (!drawer) {

      console.error(
        'Cart drawer not found'
      );

      return;

    }

    // Remove hidden state
    drawer.classList.remove(
      'closing'
    );

    // Add open state
    drawer.classList.add(
      'is-open'
    );

    if (overlay) {

      overlay.classList.add(
        'is-open'
      );

      overlay.style.display =
        'block';

      overlay.style.visibility =
        'visible';

      overlay.style.opacity =
        '1';

    }

    drawer.style.display =
      'block';

    drawer.style.visibility =
      'visible';

    drawer.style.opacity =
      '1';

    drawer.style.transform =
      'translateX(0)';

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.style.overflow =
      'hidden';

  },


  // ── CLOSE ─────────────────────────────────────────────────────
  close() {

    const drawer =
      this.getDrawer();

    const overlay =
      this.getOverlay();

    console.log(
      'Closing cart drawer...',
      drawer
    );

    if (drawer) {

      // Remove every class that can keep
      // the drawer visually open.
      drawer.classList.remove(
        'is-open',
        'open',
        'active',
        'show'
      );

      // Remove inline styles added
      // by the custom openCart() code.
      drawer.style.display =
        '';

      drawer.style.visibility =
        '';

      drawer.style.opacity =
        '';

      drawer.style.transform =
        '';

      drawer.style.right =
        '';

      drawer.style.left =
        '';

      drawer.style.transition =
        '';

      drawer.setAttribute(
        'aria-hidden',
        'true'
      );

    }

    if (overlay) {

      overlay.classList.remove(
        'is-open',
        'open',
        'active',
        'show'
      );

      overlay.style.display =
        '';

      overlay.style.visibility =
        '';

      overlay.style.opacity =
        '';

    }

    document.body.style.overflow =
      '';

    console.log(
      'Cart drawer closed'
    );

  },


  // ── INITIALISE ────────────────────────────────────────────────
  init() {

    // OPEN CART
    document.addEventListener(
      'click',
      (e) => {

        const openButton =
          e.target.closest(
            '[data-open-cart]'
          );

        if (!openButton) {
          return;
        }

        e.preventDefault();

        this.open();

      }
    );


    // CLOSE CART
    document.addEventListener(
      'click',
      (e) => {

        const closeButton =
          e.target.closest(
            '#cart-drawer .cart-drawer__close, .cart-drawer__close, [data-close-cart]'
          );

        if (!closeButton) {
          return;
        }

        e.preventDefault();

        e.stopPropagation();

        console.log(
          'Cart close button clicked'
        );

        this.close();

      }
    );


    // OVERLAY
    document.addEventListener(
      'click',
      (e) => {

        const overlay =
          e.target.closest(
            '.cart-overlay'
          );

        if (!overlay) {
          return;
        }

        if (
          e.target === overlay
        ) {

          this.close();

        }

      }
    );


    // ESCAPE
    document.addEventListener(
      'keydown',
      (e) => {

        if (
          e.key !== 'Escape'
        ) {
          return;
        }

        const drawer =
          this.getDrawer();

        if (
          drawer &&
          (
            drawer.classList.contains(
              'is-open'
            ) ||
            drawer.classList.contains(
              'open'
            ) ||
            drawer.classList.contains(
              'active'
            )
          )
        ) {

          this.close();

        }

      }
    );


    // CHECKOUT
    document.addEventListener(
      'click',
      (e) => {

        const checkoutButton =
          e.target.closest(
            '#cart-drawer .cart-drawer__footer button, #cart-drawer .cart-drawer__footer a'
          );

        if (!checkoutButton) {
          return;
        }

        const text =
          (
            checkoutButton.textContent ||
            ''
          )
          .trim()
          .toLowerCase();

        if (
          !text.includes(
            'checkout'
          ) &&
          !text.includes(
            'proceed'
          )
        ) {
          return;
        }

        e.preventDefault();

        e.stopPropagation();

        window.location.href =
          '/checkout';

      }
    );


    // ADD TO CART
    document.addEventListener(
      'submit',
      async (e) => {

        const form =
          e.target.closest(
            '[data-add-to-cart-form]'
          );

        if (!form) {
          return;
        }

        e.preventDefault();

        await this.addItem(
          form
        );

      }
    );


    // QUICK ADD
    document.addEventListener(
      'click',
      async (e) => {

        const btn =
          e.target.closest(
            '[data-quick-add]'
          );

        if (!btn) {
          return;
        }

        e.preventDefault();

        const variantId =
          btn.dataset.quickAdd;

        if (variantId) {

          await this.quickAdd(
            variantId,
            btn
          );

        }

      }
    );


    // QUANTITY
    document.addEventListener(
      'click',
      async (e) => {

        const btn =
          e.target.closest(
            '[data-cart-qty-adjust]'
          );

        if (!btn) {
          return;
        }

        e.preventDefault();

        const lineIndex =
          btn.dataset.line;

        const qty =
          parseInt(
            btn.dataset.cartQtyAdjust,
            10
          );

        await this.updateQty(
          lineIndex,
          qty
        );

      }
    );

  },


  // ── ADD ITEM ──────────────────────────────────────────────────
  async addItem(form) {

    const btn =
      form.querySelector(
        '[type="submit"]'
      );

    const originalText =
      btn?.textContent || '';

    try {

      if (btn) {

        btn.disabled = true;

        btn.textContent =
          'Adding…';

      }

      const formData =
        new FormData(form);

      const response =
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',
            headers: {
              'Accept':
                'application/json'
            },
            body: formData
          }
        );

      if (!response.ok) {

        throw new Error(
          'Add to cart failed'
        );

      }

      const item =
        await response.json();

      await this.refreshCart();

      this.open();

      Toast.show(
        `${item.product_title} added to cart ✓`
      );

    } catch (err) {

      console.error(err);

      Toast.show(
        'Something went wrong. Please try again.'
      );

    } finally {

      if (btn) {

        btn.disabled = false;

        btn.textContent =
          originalText;

      }

    }

  },


  // ── QUICK ADD ─────────────────────────────────────────────────
  async quickAdd(
    variantId,
    btn
  ) {

    const originalText =
      btn?.textContent || '';

    try {

      if (btn) {

        btn.disabled = true;

        btn.textContent =
          '…';

      }

      const response =
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              'Accept':
                'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          }
        );

      if (!response.ok) {

        throw new Error(
          'Quick add failed'
        );

      }

      const item =
        await response.json();

      await this.refreshCart();

      this.open();

      Toast.show(
        `${item.product_title} added to cart ✓`
      );

    } catch (err) {

      console.error(err);

      Toast.show(
        'Something went wrong. Please try again.'
      );

    } finally {

      if (btn) {

        btn.disabled = false;

        btn.textContent =
          originalText;

      }

    }

  },


  // ── UPDATE QUANTITY ───────────────────────────────────────────
  async updateQty(
    lineIndex,
    qty
  ) {

    try {

      const response =
        await fetch(
          '/cart/change.js',
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json'
            },
            body: JSON.stringify({
              line: lineIndex,
              quantity: qty
            })
          }
        );

      if (!response.ok) {

        throw new Error(
          'Cart update failed'
        );

      }

      await this.refreshCart();

    } catch (err) {

      console.error(err);

    }

  },


  // ── REFRESH CART ──────────────────────────────────────────────
  async refreshCart() {

    try {

      const response =
        await fetch(
          '/cart.js'
        );

      if (!response.ok) {

        throw new Error(
          'Unable to load cart'
        );

      }

      const cart =
        await response.json();

      console.log(
        'Shopify cart currency:',
        cart.currency
      );

      console.log(
        'Shopify cart total:',
        cart.total_price
      );

      this.renderCartHTML(
        cart
      );

      this.updateCartCount(
        cart.item_count
      );

      this.updateShippingBar(
        cart.total_price / 100,
        cart.currency
      );

    } catch (err) {

      console.error(
        'Failed to refresh cart:',
        err
      );

    }

  },


  // ── RENDER CART ───────────────────────────────────────────────
  renderCartHTML(cart) {

    const body =
      document.querySelector(
        '.cart-drawer__body'
      );

    const totalEl =
      document.querySelector(
        '.cart-drawer__total-amt'
      );

    if (!body) {
      return;
    }

    if (
      cart.item_count === 0
    ) {

      body.innerHTML = `
        <div class="cart-drawer__empty">
          <div class="cart-drawer__empty-icon">
            🛒
          </div>
          <p>
            Your cart is empty.<br>
            Browse our products to get started.
          </p>
        </div>
      `;

    } else {

      body.innerHTML =
        cart.items
          .map(
            (item, i) => {

              const variantTitle =
                item.variant_title &&
                item.variant_title !==
                  'Default Title'
                  ? item.variant_title
                  : '';

              return `
                <div class="cart-item">

                  <img
                    class="cart-item__img"
                    src="${item.image || ''}"
                    alt="${item.title || item.product_title || ''}"
                    width="70"
                    height="70"
                  >

                  <div class="cart-item__details">

                    <div class="cart-item__name">
                      ${item.product_title || item.title || ''}
                    </div>

                    ${
                      variantTitle
                        ? `
                          <div class="cart-item__variant">
                            ${variantTitle}
                          </div>
                        `
                        : ''
                    }

                    <div class="cart-item__price">
                      ${this.formatMoney(
                        item.line_price,
                        cart.currency
                      )}
                    </div>

                    <div class="cart-item__qty">

                      <button
                        type="button"
                        class="cart-item__qty-btn"
                        data-cart-qty-adjust="${Math.max(
                          0,
                          item.quantity - 1
                        )}"
                        data-line="${i + 1}"
                        aria-label="Decrease quantity"
                      >
                        −
                      </button>

                      <span class="cart-item__qty-val">
                        ${item.quantity}
                      </span>

                      <button
                        type="button"
                        class="cart-item__qty-btn"
                        data-cart-qty-adjust="${
                          item.quantity + 1
                        }"
                        data-line="${i + 1}"
                        aria-label="Increase quantity"
                      >
                        +
                      </button>

                    </div>

                  </div>

                </div>
              `;

            }
          )
          .join('');

    }

    if (totalEl) {

      totalEl.textContent =
        this.formatMoney(
          cart.total_price,
          cart.currency
        );

    }

  },


  // ── CART COUNT ────────────────────────────────────────────────
  updateCartCount(count) {

    const badges =
      document.querySelectorAll(
        '[data-cart-count]'
      );

    badges.forEach(
      (badge) => {

        badge.textContent =
          count;

        badge.style.display =
          count > 0
            ? 'flex'
            : 'none';

      }
    );

    const label =
      document.querySelector(
        '[data-cart-count-label]'
      );

    if (label) {

      label.textContent =
        count;

    }

  },


  // ── SHIPPING BAR ──────────────────────────────────────────────
  updateShippingBar(
    total,
    currency
  ) {

    const threshold =
      75;

    const bar =
      document.querySelector(
        '.cart-drawer__shipping'
      );

    if (!bar) {
      return;
    }

    const remaining =
      Math.max(
        0,
        threshold -
          Number(total)
      );

    if (remaining > 0) {

      bar.innerHTML = `
        🚚 Add
        <strong>
          ${this.formatMoney(
            remaining * 100,
            currency
          )}
        </strong>
        more for free shipping
      `;

    } else {

      bar.innerHTML = `
        🎉
        <strong>
          You qualify for free shipping!
        </strong>
      `;

    }

  }

};


// ── MOBILE NAV ───────────────────────────────────────────────────
const MobileNav = {

  overlay:
    document.querySelector(
      '.mobile-nav-overlay'
    ),

  open() {

    this.overlay
      ?.classList.add('is-open');

    document.body.style.overflow =
      'hidden';

  },

  close() {

    this.overlay
      ?.classList.remove('is-open');

    document.body.style.overflow =
      '';

  },

  init() {

    document
      .querySelector(
        '[data-mobile-menu-open]'
      )
      ?.addEventListener(
        'click',
        () => this.open()
      );

    document
      .querySelector(
        '[data-mobile-menu-close]'
      )
      ?.addEventListener(
        'click',
        () => this.close()
      );

    this.overlay
      ?.addEventListener(
        'click',
        (e) => {

          if (
            e.target === this.overlay
          ) {
            this.close();
          }

        }
      );

  }

};


// ── FAQ ACCORDION ────────────────────────────────────────────────
const FAQ = {

  init() {

    document
      .querySelectorAll(
        '.faq-question'
      )
      .forEach((btn) => {

        btn.addEventListener(
          'click',
          () => {

            const item =
              btn.closest(
                '.faq-item'
              );

            const isOpen =
              item.classList.contains(
                'is-open'
              );

            // Close all
            document
              .querySelectorAll(
                '.faq-item.is-open'
              )
              .forEach((i) =>
                i.classList.remove(
                  'is-open'
                )
              );

            // Open clicked
            if (!isOpen) {

              item.classList.add(
                'is-open'
              );

            }

          }
        );

      });

  }

};


// ── TOAST NOTIFICATION ───────────────────────────────────────────
const Toast = {

  el:
    document.getElementById(
      'vm3-toast'
    ),

  timer: null,

  show(
    message,
    duration = 3000
  ) {

    if (!this.el) return;

    const msgEl =
      this.el.querySelector(
        '.toast-msg'
      );

    if (msgEl) {
      msgEl.textContent = message;
    }

    this.el.classList.add(
      'is-active'
    );

    clearTimeout(
      this.timer
    );

    this.timer =
      setTimeout(
        () =>
          this.el.classList.remove(
            'is-active'
          ),
        duration
      );

  }

};


// ── STICKY HEADER SHADOW ─────────────────────────────────────────
const StickyHeader = {

  header:
    document.querySelector(
      '.site-header'
    ),

  init() {

    if (!this.header) return;

    const observer =
      new IntersectionObserver(
        ([entry]) => {

          this.header.style.boxShadow =
            entry.isIntersecting
              ? '0 2px 16px rgba(10,60,110,.1)'
              : '0 4px 24px rgba(10,60,110,.18)';

        },
        {
          rootMargin:
            '-1px 0px 0px 0px',
          threshold: [1]
        }
      );

    const sentinel =
      document.createElement(
        'div'
      );

    sentinel.style.cssText =
      'height:1px;width:100%;position:absolute;top:0;';

    document.body.prepend(
      sentinel
    );

    observer.observe(
      sentinel
    );

  }

};


// ── VARIANT SELECTOR ─────────────────────────────────────────────
const VariantSelector = {

  init() {

    document
      .querySelectorAll(
        '[data-variant-btn]'
      )
      .forEach((btn) => {

        btn.addEventListener(
          'click',
          () => {

            const group =
              btn.closest(
                '[data-variant-group]'
              );

            group
              ?.querySelectorAll(
                '[data-variant-btn]'
              )
              .forEach((b) =>
                b.classList.remove(
                  'active'
                )
              );

            btn.classList.add(
              'active'
            );

            // Update hidden input
            const variantId =
              btn.dataset.variantId;

            const price =
              btn.dataset.price;

            const form =
              btn.closest('form');

            if (form) {

              const input =
                form.querySelector(
                  '[name="id"]'
                );

              if (input) {
                input.value =
                  variantId;
              }

            }

            // Update product price
            const priceEl =
              document.querySelector(
                '[data-pdp-price]'
              );

            if (
              priceEl &&
              price
            ) {

              const currency =
                document.documentElement
                  .dataset.currency ||
                window.Shopify?.currency?.active ||
                'AUD';

              priceEl.textContent =
                CartDrawer.formatMoney(
                  parseInt(
                    price,
                    10
                  ),
                  currency
                );

            }

          }
        );

      });

  }

};


// ── QTY SELECTOR ─────────────────────────────────────────────────
const QtySelector = {

  init() {

    document
      .querySelectorAll(
        '[data-qty-decrease]'
      )
      .forEach((btn) => {

        btn.addEventListener(
          'click',
          () => {

            const input =
              btn
                .closest(
                  '[data-qty-wrap]'
                )
                ?.querySelector(
                  'input'
                );

            if (input) {

              input.value =
                Math.max(
                  1,
                  parseInt(
                    input.value,
                    10
                  ) - 1
                );

            }

          }
        );

      });

    document
      .querySelectorAll(
        '[data-qty-increase]'
      )
      .forEach((btn) => {

        btn.addEventListener(
          'click',
          () => {

            const input =
              btn
                .closest(
                  '[data-qty-wrap]'
                )
                ?.querySelector(
                  'input'
                );

            if (input) {

              input.value =
                parseInt(
                  input.value,
                  10
                ) + 1;

            }

          }
        );

      });

  }

};


// ── SCROLL-TRIGGERED ANIMATIONS ──────────────────────────────────
const ScrollAnimations = {

  init() {

    if (
      !(
        'IntersectionObserver'
        in window
      )
    ) {
      return;
    }

    const observer =
      new IntersectionObserver(
        (entries) => {

          entries.forEach(
            (entry) => {

              if (
                entry.isIntersecting
              ) {

                entry.target.classList.add(
                  'animate-fade-up'
                );

                observer.unobserve(
                  entry.target
                );

              }

            }
          );

        },
        {
          threshold: 0.1
        }
      );

    document
      .querySelectorAll(
        '[data-animate]'
      )
      .forEach((el) =>
        observer.observe(el)
      );

  }

};


// ── PRODUCT IMAGE GALLERY ────────────────────────────────────────
const ProductGallery = {

  init() {

    document
      .querySelectorAll(
        '[data-gallery-thumb]'
      )
      .forEach((thumb) => {

        thumb.addEventListener(
          'click',
          () => {

            const gallery =
              thumb.closest(
                '[data-gallery]'
              );

            const main =
              gallery?.querySelector(
                '[data-gallery-main]'
              );

            const src =
              thumb.dataset.src;

            const srcset =
              thumb.dataset.srcset;

            gallery
              ?.querySelectorAll(
                '[data-gallery-thumb]'
              )
              .forEach((t) =>
                t.classList.remove(
                  'active'
                )
              );

            thumb.classList.add(
              'active'
            );

            if (
              main &&
              src
            ) {

              main.src = src;

              if (srcset) {
                main.srcset =
                  srcset;
              }

            }

          }
        );

      });

  }

};


// ── ANNOUNCEMENT BAR AUTO-ROTATE ──────────────────────────────────
const AnnouncementBar = {

  init() {

    const bar =
      document.querySelector(
        '[data-ann-bar]'
      );

    if (!bar) return;

    const messages =
      bar.querySelectorAll(
        '[data-ann-msg]'
      );

    if (
      messages.length < 2
    ) {
      return;
    }

    let current = 0;

    messages.forEach(
      (message, i) => {

        message.style.display =
          i === 0
            ? ''
            : 'none';

      }
    );

    setInterval(
      () => {

        messages[
          current
        ].style.display =
          'none';

        current =
          (current + 1) %
          messages.length;

        messages[
          current
        ].style.display =
          '';

      },
      4000
    );

  }

};


// ── FORM VALIDATION ───────────────────────────────────────────────
const TradeForm = {

  init() {

    const form =
      document.querySelector(
        '[data-trade-form]'
      );

    if (!form) return;

    form.addEventListener(
      'submit',
      async (e) => {

        e.preventDefault();

        const btn =
          form.querySelector(
            '[type="submit"]'
          );

        if (btn) {
          btn.textContent =
            'Submitting…';
        }

        // In production:
        // POST to Shopify contact form
        // or Klaviyo.
        //
        // For now, simulate success.
        await new Promise(
          (resolve) =>
            setTimeout(
              resolve,
              1200
            )
        );

        Toast.show(
          'Application received! We\'ll be in touch within 24 hours.'
        );

        if (btn) {
          btn.textContent =
            'Application Sent ✓';
        }

      }
    );

  }

};


// ── INITIALISE ALL ────────────────────────────────────────────────
document.addEventListener(
  'DOMContentLoaded',
  () => {

    CartDrawer.init();

    // Sync cart count on load
    CartDrawer.refreshCart();

    MobileNav.init();

    FAQ.init();

    StickyHeader.init();

    VariantSelector.init();

    QtySelector.init();

    ScrollAnimations.init();

    ProductGallery.init();

    AnnouncementBar.init();

    TradeForm.init();

  }
);


// Export for use in section-specific scripts
window.Vm3 = {
  Toast,
  CartDrawer
};